/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
  .fill {
    stroke: ${theme.color.disableTxt};
  }
`

export default function BlockManagementIco() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" css={Color}>
      <g id="그룹_6968" data-name="그룹 6968" transform="translate(-151 -208)">
        <rect id="사각형_6694" data-name="사각형 6694" width="18" height="18" transform="translate(151 208)" fill="#fff" opacity="0"/>
        <g id="그룹_32043" className="fill" data-name="그룹 32043" transform="translate(0.009 0.009)">
          <circle id="타원_694" data-name="타원 694" cx="6" cy="6" r="6" transform="translate(153.991 210.991)" fill="none" stroke="#6f777e" strokeWidth="1.5"/>
          <path id="패스_42723" className="fill" data-name="패스 42723" d="M164.15,211.628l-9.079,9.079" transform="translate(0.38 0.823)" fill="none" stroke="#6f777e" strokeWidth="1.5"/>
        </g>
      </g>
    </svg>

  )
}
